
import { t } from 'i18next';
import { UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { ControlledTextField } from '@frontend/features/common/components/ControlledTextField';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { fromDDMMYYYYToYYYYMMDD, getExactAgeForDOB, isValidDDMMYYYY } from '@frontend/features/common/helper';

export interface Pax {
  id: string;
  name: string;
  surname: string;
  dob: string;
  age: number;
  ageOnSearch: number;
}

export interface Occupancy {
  id: number;
  paxes: Pax[];
}

export interface Form {
  occupancies: Occupancy[]
}

interface Props {
  register: UseFormRegister<Form>;
  setValue: UseFormSetValue<Form>;
  occupancyIndex: number;
  paxIndex: number;
  control: any;
  checkinDate?: string;
}

export const CartPaxForm: React.FC<Props> = ({
  occupancyIndex,
  paxIndex,
  control,
  checkinDate,
  register,
  setValue
}) => (   
  <Box
    key={`${occupancyIndex}-${paxIndex}`}
    display="flex"
    flexDirection="column"
    gap={3}
  >
    <input
      {...register(`occupancies.${occupancyIndex}.paxes.${paxIndex}.id`)}
      type="hidden"
    />
    <input
      {...register(`occupancies.${occupancyIndex}.paxes.${paxIndex}.age`)}
      type="hidden"
    />
    <input
      {...register(`occupancies.${occupancyIndex}.paxes.${paxIndex}.ageOnSearch`)}
      type="hidden"
    />
        
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant='subtitle2' color="text.primary">{t('hotels.fares.hotelPaxData.name.title')}</Typography>
      <ControlledTextField
        shrink
        control={control}
        name={`occupancies.${occupancyIndex}.paxes.${paxIndex}.name`}
        required
        errorMessage={t('common.form.required')}
        size="small"
      />
    </Box>
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant='subtitle2' color="text.primary">{t('hotels.fares.hotelPaxData.surname.title')}</Typography>
      <ControlledTextField
        shrink
        control={control}
        name={`occupancies.${occupancyIndex}.paxes.${paxIndex}.surname`}
        required
        errorMessage={t('common.form.required')}
        fullWidth
        size="small"
      />
    </Box>
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant='subtitle2' color="text.primary">{t('hotels.fares.hotelPaxData.birthDate.title')}</Typography>
      <ControlledTextField
        shrink
        required
        fullWidth
        control={control}
        name={`occupancies.${occupancyIndex}.paxes.${paxIndex}.dob`}
        type="date"
        size="small"
        errorMessage={t('common.form.required')}
        onChange={(event) => {
          if (isValidDDMMYYYY(event.target.value)) {
            setValue(
              `occupancies.${occupancyIndex}.paxes.${paxIndex}.age`,
              getExactAgeForDOB(fromDDMMYYYYToYYYYMMDD(event.target.value), checkinDate),
              { shouldValidate: true }
            );
          }
        }}
      />
    </Box>
  </Box>
);
